import { RefObject } from 'react';

export const useScrollingHelper = () => {
  return (elemRef: RefObject<HTMLElement | null>, to?: 'top' | 'bottom') => {
    if (!elemRef?.current) {
      return;
    }

    const elemRect = elemRef.current.getBoundingClientRect();
    const elemY = to === 'bottom' ? elemRect.bottom : elemRect.top;
    const offsetY = to === 'bottom' ? elemY - window.innerHeight : elemY;

    window.scrollTo({
      top: offsetY + window.scrollY,
      behavior: 'smooth',
    });
  };
};
